import { Photo } from "@/components/shared/Photo";

// Uma dor por frente (site, automação, sistema, consultoria) — a home é visão geral.
const antes = [
  "Site parado, que ninguém encontra no Google e não gera contato",
  "Lead esperando horas no WhatsApp porque ninguém viu a mensagem",
  "Operação inteira em planilha que só uma pessoa entende",
  "Decisão tomada no escuro, sem número confiável",
];

const depois = [
  "Site rápido, encontrado no Google, levando a visita até o contato",
  "Lead respondido em minutos, com follow-up automático",
  "Sistema próprio, com o dado num lugar só",
  "Prioridades claras e relatório pronto, sem fechamento manual",
];

const BeforeAfter = () => (
  <section className="border-y border-border bg-card">
    <div className="mx-auto max-w-[1180px] px-8 py-[72px] max-[900px]:px-5">
      <h2 className="mb-[34px] text-[31px] font-bold tracking-[-0.03em]">O que muda na prática</h2>
      <div className="grid grid-cols-2 gap-[18px] max-[900px]:grid-cols-1">
        <div className="overflow-hidden rounded-[18px] border border-border bg-background">
          <div className="aspect-[16/7] overflow-hidden border-b border-border">
            <Photo id="dono-sobrecarregado" sizes="(max-width: 900px) 100vw, 560px" />
          </div>
          <div className="p-[26px]">
            <div className="text-xs font-bold uppercase tracking-[0.07em] text-bad">Hoje</div>
            <div className="mt-[18px] flex flex-col gap-[13px]">
              {antes.map((t) => (
                <div key={t} className="flex items-start gap-[11px]">
                  <span className="mt-px flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-bad-soft text-[11px] font-bold text-bad">
                    ×
                  </span>
                  <span className="text-sm leading-[1.55] text-muted-foreground">{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="overflow-hidden rounded-[18px] border-[1.5px] border-primary bg-accent">
          <div className="aspect-[16/7] overflow-hidden border-b border-primary/30">
            <Photo id="equipe-tranquila" sizes="(max-width: 900px) 100vw, 560px" />
          </div>
          <div className="p-[26px]">
            <div className="text-xs font-bold uppercase tracking-[0.07em] text-primary">Depois</div>
            <div className="mt-[18px] flex flex-col gap-[13px]">
              {depois.map((t) => (
                <div key={t} className="flex items-start gap-[11px]">
                  <span className="mt-px flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-primary-foreground">
                    ✓
                  </span>
                  <span className="text-sm leading-[1.55] text-foreground">{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BeforeAfter;
